import React from "react";
import { Collapse, Col, Row } from "reactstrap";
import CartStudentList from "./CartStudentList";

class CartItem extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: false };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    return (
      <div
        style={{
          backgroundColor: this.props.isLatestAdded
            ? "rgba(77, 189, 116, .3)"
            : "white",
          backgroundBlendMode: "lighten",
          borderRadius: ".5em",
        }}
      >
        <Row className="p-2">
          <Col
            lg="9"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            <Row className="ps-1">
              <Col>
                <strong>Produkt</strong>: {this.props.cartItem?.name}
              </Col>
            </Row>

            <Row className="ps-1">
              <Col>
                <strong>Antal: </strong>
                {this.props.cartItem?.addedStudents?.length}
              </Col>
            </Row>

            <Row className="ps-1">
              <Col>
                <strong>Á-pris</strong>: {this.props.cartItem?.priceStudent} kr
              </Col>
            </Row>
          </Col>

          <Col lg="3" className="pt-1">
            <Row className="pb-2 pe-1">
              <Col>
                <span>
                  {!this.props.readonly && (
                    <button
                      style={{ cursor: "pointer", width: "115px" }}
                      onClick={() => this.props.handleDeleteFromCart()}
                      type="button"
                      className="btn btn-sm btn-block btn-danger float-end"
                    >
                      Ta bort <i className="fa fa-trash" />
                    </button>
                  )}
                </span>
              </Col>
            </Row>
            <Row className="pe-1 pt-1 pb-1">
              <Col>
                <span>
                  <button
                    style={{ cursor: "pointer", width: "115px" }}
                    onClick={this.toggle}
                    type="button"
                    className="btn btn-sm btn-block btn-primary float-end"
                  >
                    {this.state.collapse ? "Dölj" : "Visa"} elever (
                    {this.props.cartItem?.addedStudents?.length}){" "}
                    <i className="fa fa-users" />
                  </button>
                </span>
              </Col>
            </Row>
          </Col>
          <Col>
            <Collapse isOpen={this.state.collapse}>
              <div className="ps-1 pe-1">
                <CartStudentList
                  addedStudentList={this.props.cartItem.addedStudents}
                />
              </div>
            </Collapse>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CartItem;
